const listeners = new Set();

export function emitCariSync(event) {
  for (const fn of listeners) {
    try {
      fn(event || {});
    } catch (_) {
      // ignore listener errors
    }
  }
}

export function subscribeCariSync(handler) {
  if (typeof handler !== 'function') return () => {};
  listeners.add(handler);
  return () => listeners.delete(handler);
}

